module.exports = __webpack_public_path__ + "static/img/bg-id.eb356b9c.png";